import {TextField, styled} from "@reside/ui";
import {useFormikContext} from "formik";
import {generatePathPreview} from "./helpers";
import {PATH_VARIABLES} from "./consts";
import {EventTriggerForm} from "../../services/HubAndSpokeService";
import {FormSectionHint} from "./styles";

export const DocumentPaths = (): JSX.Element => {
  const {values} = useFormikContext<EventTriggerForm>();

  return (
    <>
      <TextField
        type="document_path"
        name="document_path"
        label="Target path"
        suffix=".pdf"
      />
      <Preview>
        <strong>Preview:</strong>{" "}
        <code>{generatePathPreview(values.document_path)}</code>
      </Preview>
      <FormSectionHint>
        Where the PDF is saved on the SFTP server. Available variables:
      </FormSectionHint>
      <VariablesList>
        {PATH_VARIABLES.map(({variable, description}) => (
          <VariableRow key={variable}>
            <dt>
              <code>{variable}</code>
            </dt>
            <dd>{description}</dd>
          </VariableRow>
        ))}
      </VariablesList>
    </>
  );
};

const Preview = styled.p`
  margin: ${({theme}) => `${theme.space[2]}px 0 ${theme.space[4]}px`};
  font-size: ${({theme}) => theme.fontSize[2]}px;
  word-break: break-all;
`;

const VariablesList = styled.dl`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({theme}) => theme.space[1]}px;
  margin: 0;
  font-size: ${({theme}) => theme.fontSize[2]}px;

  @media (min-width: ${({theme}) => theme.breakpoint.md}px) {
    grid-template-columns: 1fr 1fr;
    column-gap: ${({theme}) => theme.space[6]}px;
  }
`;

const VariableRow = styled.div`
  display: flex;
  gap: ${({theme}) => theme.space[2]}px;

  dt {
    flex: 0 0 170px;
  }

  dd {
    margin: 0;
    color: ${({theme}) => theme.color.gray150};
  }
`;
